/***************************

    Тасалбарын сайт (tickets.sonsy.mn)

    Арга хэмжээний тасалбарын урсгал бүхэлдээ тусдаа домэйн руу
    шилжсэн (`sonsy-tickets-web` төсөл). Энэ сайтад үлдсэн цорын ганц
    холбоо нь Premium Duo → тасалбарын ваучер: төлбөр хийгдмэгц
    хэрэглэгчийг тасалбар руу нь буцаана.

    Хаяг нь ЗААВАЛ бүтэн байх ёстой — харьцангуй зам нь энэ домэйн
    дээр 404 болно.

***************************/

export const TICKETS_URL = (
  process.env.REACT_APP_TICKETS_URL || "https://tickets.sonsy.mn"
).replace(/\/+$/, "");

export const ticketsUrl = (path = "/") =>
  `${TICKETS_URL}${path.startsWith("/") ? "" : "/"}${path}`;
